import { render } from "./StudyModules.vue?vue&type=template&id=6e2fddbc"
import script from "./StudyModules.vue?vue&type=script&lang=js"
export * from "./StudyModules.vue?vue&type=script&lang=js"

import exportComponent from "/srv/data/www/krasp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/StudyModules.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6e2fddbc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6e2fddbc', __exports__)) {
    api.reload('6e2fddbc', __exports__)
  }
  
  module.hot.accept("./StudyModules.vue?vue&type=template&id=6e2fddbc", () => {
    api.rerender('6e2fddbc', render)
  })

}


export default __exports__